import { Dispatch, Action } from 'redux';
import axios from 'axios';
import { Validation, ValidationReport } from '../reducers/validations.reducer'
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
// import { NotificationManager } from 'react-notifications';
import { getValidationsAPI, getValidationAPI, getValidationLevAPI, getValidationHistoryIvAPI, getValidationHistoryLevAPI, getAPIValidationsAPI, getIVAPIValidationAPI, getLEVAPIValidationAPI, restartValidationAPI, bulkRestartDelayedValidationsAPI, getIvRiskSummaryAPI, getLevRiskSummaryAPI } from '../../config/config'


// Action types
export const GET_VALIDATIONS_REQUEST = 'GET_VALIDATIONS_REQUEST';
export const GET_VALIDATIONS_SUCCESS = 'GET_VALIDATIONS_SUCCESS';
export const GET_VALIDATIONS_FAILURE = 'GET_VALIDATIONS_FAILURE';

export const GET_VALIDATION_REQUEST = 'GET_VALIDATION_REQUEST';
export const GET_VALIDATION_SUCCESS = 'GET_VALIDATION_SUCCESS';
export const GET_VALIDATION_FAILURE = 'GET_VALIDATION_FAILURE';

export const GET_VALIDATION_HISTORY_REQUEST = 'GET_VALIDATION_HISTORY_REQUEST';
export const GET_VALIDATION_HISTORY_SUCCESS = 'GET_VALIDATION_HISTORY_SUCCESS';
export const GET_VALIDATION_HISTORY_FAILURE = 'GET_VALIDATION_HISTORY_FAILURE';

export const RESTART_VALIDATION_REQUEST = 'RESTART_VALIDATION_REQUEST';
export const RESTART_VALIDATION_SUCCESS = 'RESTART_VALIDATION_SUCCESS';
export const RESTART_VALIDATION_FAILURE = 'RESTART_VALIDATION_FAILURE';

export const BULK_RESTART_VALIDATIONS_REQUEST = 'BULK_RESTART_VALIDATIONS_REQUEST';
export const BULK_RESTART_VALIDATIONS_SUCCESS = 'BULK_RESTART_VALIDATIONS_SUCCESS';
export const BULK_RESTART_VALIDATIONS_FAILURE = 'BULK_RESTART_VALIDATIONS_FAILURE';

export const RESET_VALIDATIONS_STATE = 'RESET_VALIDATIONS_STATE'
export const GET_RISK_SUMMARY_REQUEST = 'GET_RISK_SUMMARY_REQUEST'
export const GET_RISK_SUMMARY_SUCCESS = 'GET_RISK_SUMMARY_SUCCESS'
export const GET_RISK_SUMMARY_FAILURE = 'GET_RISK_SUMMARY_FAILURE'
interface GetRiskSummaryRequest extends Action<typeof GET_RISK_SUMMARY_REQUEST> { }
interface GetRiskSummarySuccess extends Action<typeof GET_RISK_SUMMARY_SUCCESS> {
    payload: { clear: number, investigate: number, high: number }
}
interface GetRiskSummaryFailure extends Action<typeof GET_RISK_SUMMARY_FAILURE> { payload: string }
export const getRiskSummaryRequest = (): GetRiskSummaryRequest => ({ type: GET_RISK_SUMMARY_REQUEST })
export const getRiskSummarySuccess = (data: { clear: number, investigate: number, high: number }): GetRiskSummarySuccess => ({ type: GET_RISK_SUMMARY_SUCCESS, payload: data })
export const getRiskSummaryFailure = (error: string): GetRiskSummaryFailure => ({ type: GET_RISK_SUMMARY_FAILURE, payload: error })
export const getIvRiskSummary = (uuid: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(getRiskSummaryRequest())
            const res = await getIvRiskSummaryAPI(uuid)
            if (res?.status === 200) dispatch(getRiskSummarySuccess(res.data))
            else dispatch(getRiskSummaryFailure(res?.data?.message || 'Something went wrong'))
        } catch (e: any) {
            dispatch(getRiskSummaryFailure(e.message))
        }
    }
}

export const getLevRiskSummary = (uuid: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(getRiskSummaryRequest())
            const res = await getLevRiskSummaryAPI(uuid)
            if (res?.status === 200) dispatch(getRiskSummarySuccess(res.data))
            else dispatch(getRiskSummaryFailure(res?.data?.message || 'Something went wrong'))
        } catch (e: any) {
            dispatch(getRiskSummaryFailure(e.message))
        }
    }
}

interface GetValidationsRequest extends Action<typeof GET_VALIDATIONS_REQUEST> { }
interface GetValidationsSuccess extends Action<typeof GET_VALIDATIONS_SUCCESS> {
    payload: { validations: Validation[] , totalCount: number, page:number }
}
interface GetValidationsFailure extends Action<typeof GET_VALIDATIONS_FAILURE> {
    payload: string
}

interface GetValidationRequest extends Action<typeof GET_VALIDATION_REQUEST> { }
interface GetValidationSuccess extends Action<typeof GET_VALIDATION_SUCCESS> {
    payload: ValidationReport
}
interface GetValidationFailure extends Action<typeof GET_VALIDATION_FAILURE> {
    payload: string
}

interface GetValidationHistoryRequest extends Action<typeof GET_VALIDATION_HISTORY_REQUEST> { }
interface GetValidationHistorySuccess extends Action<typeof GET_VALIDATION_HISTORY_SUCCESS> {
    payload: ValidationReport
}
interface GetValidationHistoryFailure extends Action<typeof GET_VALIDATION_HISTORY_FAILURE> {
    payload: string
}

interface RestartValidationRequest extends Action<typeof RESTART_VALIDATION_REQUEST> { }
interface RestartValidationSuccess extends Action<typeof RESTART_VALIDATION_SUCCESS> {
    payload: ValidationReport
}
interface RestartValidationFailure extends Action<typeof RESTART_VALIDATION_FAILURE> {
    payload: string
}

interface BulkRestartValidationsRequest extends Action<typeof BULK_RESTART_VALIDATIONS_REQUEST> { }
interface BulkRestartValidationsSuccess extends Action<typeof BULK_RESTART_VALIDATIONS_SUCCESS> {
    payload: any
}
interface BulkRestartValidationsFailure extends Action<typeof BULK_RESTART_VALIDATIONS_FAILURE> {
    payload: string
}


interface ResetValidationState extends Action<typeof RESET_VALIDATIONS_STATE> { }

export type ActionTypes = GetValidationsRequest | GetValidationsSuccess | GetValidationsFailure
    | GetValidationRequest | GetValidationSuccess | GetValidationFailure 
    | GetValidationHistoryRequest | GetValidationHistorySuccess | GetValidationHistoryFailure
    | RestartValidationRequest | RestartValidationSuccess | RestartValidationFailure
    | BulkRestartValidationsRequest | BulkRestartValidationsSuccess | BulkRestartValidationsFailure
    | ResetValidationState
    | GetRiskSummaryRequest | GetRiskSummarySuccess | GetRiskSummaryFailure

// Action creators
const getValidationsRequest = (): GetValidationsRequest => ({ type: GET_VALIDATIONS_REQUEST });
const getValidationsSuccess = (data: Validation[], totalCount: number, page: number): GetValidationsSuccess => ({ type: GET_VALIDATIONS_SUCCESS, payload: {validations: data , totalCount, page} });
const getValidationsFailure = (error: string): GetValidationsFailure => ({ type: GET_VALIDATIONS_FAILURE, payload: error });

const getValidationRequest = (): GetValidationRequest => ({ type: GET_VALIDATION_REQUEST });
const getValidationSuccess = (data: ValidationReport): GetValidationSuccess => ({ type: GET_VALIDATION_SUCCESS, payload: data });
const getValidationFailure = (error: string): GetValidationFailure => ({ type: GET_VALIDATION_FAILURE, payload: error });

const getValidationHistoryRequest = (): GetValidationHistoryRequest => ({ type: GET_VALIDATION_HISTORY_REQUEST });
const getValidationHistorySuccess = (data: ValidationReport): GetValidationHistorySuccess => ({ type: GET_VALIDATION_HISTORY_SUCCESS, payload: data });
const getValidationHistoryFailure = (error: string): GetValidationHistoryFailure => ({ type: GET_VALIDATION_HISTORY_FAILURE, payload: error });

const restartValidationRequest = (): RestartValidationRequest => ({ type: RESTART_VALIDATION_REQUEST });
const restartValidationSuccess = (data: ValidationReport): RestartValidationSuccess => ({ type: RESTART_VALIDATION_SUCCESS, payload: data });
const restartValidationFailure = (error: string): RestartValidationFailure => ({ type: RESTART_VALIDATION_FAILURE, payload: error });

const bulkRestartValidationsRequest = (): BulkRestartValidationsRequest => ({ type: BULK_RESTART_VALIDATIONS_REQUEST });
const bulkRestartValidationsSuccess = (data: any): BulkRestartValidationsSuccess => ({ type: BULK_RESTART_VALIDATIONS_SUCCESS, payload: data });
const bulkRestartValidationsFailure = (error: string): BulkRestartValidationsFailure => ({ type: BULK_RESTART_VALIDATIONS_FAILURE, payload: error });

const resetValidationState = (): ResetValidationState => ({ type: RESET_VALIDATIONS_STATE })


// Async action creators
const getValidations = (params?:any) => {
    return async (dispatch: Dispatch) => {
        try {
            let query = ''
            if(params){
                Object.keys(params)?.map((key, i)=>{
                    if(i===0){
                        query = `?${key}=${params[key]}`
                    }else{
                        query = query + `&${key}=${params[key]}`
                    }
                })
            }
            if(params.page <= 0){
                dispatch(getValidationsRequest());
            }
            const response = await getValidationsAPI(query)
            console.log(response)
            dispatch(getValidationsSuccess(response?.data?.validations || [], response?.data?.totalCount, response?.data?.page || 0))

        } catch (error: any) {
            console.log('error', error)
            //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
            dispatch(getValidationsFailure(error.message));
        }
    };
};

const getAPIValidations = (params?:any, subAction?: any) => {
    return async (dispatch: Dispatch) => {
        try {
            let query = ''
            if(params){
                Object.keys(params)?.map((key, i)=>{
                    if(i===0){
                        query = `?${key}=${params[key]}`
                    }else{
                        query = query + `&${key}=${params[key]}`
                    }
                })
            }
            if(params?.page <= 0){
                dispatch(getValidationsRequest());
            }
            const response = await getAPIValidationsAPI(query)
            console.log(response)
            dispatch(getValidationsSuccess(response?.data?.validations || [], response?.data?.totalCount, response?.data?.page || 0))

        } catch (error: any) {
            console.log('error', error)
            //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
            dispatch(getValidationsFailure(error.message));
        }

        if(subAction){
            subAction();
        }
    };
};


const getValidation = (uuid: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(getValidationRequest());
            const response = await getValidationAPI( uuid)
            if(response?.status === 200){
                dispatch(getValidationSuccess(response?.data || null))
            }else{
                dispatch(getValidationFailure(response?.data?.message || 'Something went wrong'));
            }
        } catch (error: any) {
            console.log('error', error)
            //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
            dispatch(getValidationFailure(error.message));
        }
    };
};

const getAPIValidation = (uuid: string, type: 'IV'| 'LEV', params?: Record<string, any>) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(getValidationRequest());
            let query = ''
            if (params) {
                Object.keys(params).forEach((key, i) => {
                    const v = params[key]
                    if (v === undefined || v === null || v === '') return
                    query += (i === 0 ? '?' : '&') + `${encodeURIComponent(key)}=${encodeURIComponent(v)}`
                })
            }
            const response = type === 'IV' ? await getIVAPIValidationAPI( uuid, query) : await getLEVAPIValidationAPI(uuid, query)
            if(response?.status === 200){
                dispatch(getValidationSuccess(response?.data || null))
            }else{
                dispatch(getValidationFailure(response?.data?.message || 'Something went wrong'));
            }
        } catch (error: any) {
            console.log('error', error)
            //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
            dispatch(getValidationFailure(error.message));
        }
    };
};

const getValidationHistoryIv= (uuid: string, ruuid: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(getValidationHistoryRequest());
            const response = await getValidationHistoryIvAPI( uuid, ruuid)
            if(response?.status === 200){
                dispatch(getValidationHistorySuccess(response?.data?.reports || []))
            }else{
                dispatch(getValidationHistoryFailure(response?.data?.message || 'Something went wrong'));
            }
        } catch (error: any) {
            console.log('error', error)
            //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
            dispatch(getValidationHistoryFailure(error.message));
        }
    };
};

const getValidationHistoryLev= (uuid: string, ruuid: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(getValidationHistoryRequest());
            const response = await getValidationHistoryLevAPI( uuid, ruuid)
            if(response?.status === 200){
                dispatch(getValidationHistorySuccess(response?.data?.reports || []))
            }else{
                dispatch(getValidationHistoryFailure(response?.data?.message || 'Something went wrong'));
            }
        } catch (error: any) {
            console.log('error', error)
            //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
            dispatch(getValidationHistoryFailure(error.message));
        }
    };
};


const getValidationLev = (uuid: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(getValidationRequest());
            const response = await getValidationLevAPI(uuid)
            if(response?.status === 200){
                dispatch(getValidationSuccess(response?.data || null))
            }else{
                dispatch(getValidationFailure(response?.data?.message || 'Something went wrong'));
            }
        } catch (error: any) {
            console.log('error', error)
            //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
            dispatch(getValidationFailure(error.message));
        }
    };
};

const restartValidation = (uuid: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(restartValidationRequest());
            const response = await restartValidationAPI(uuid); // Assuming restart is a new validation
            if(response?.status === 200){
                dispatch(restartValidationSuccess(response?.data || null));
            } else {
                dispatch(restartValidationFailure(response?.data?.message || 'Something went wrong'));
            }
        } catch (error: any) {
            console.log('error', error)
            //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
            dispatch(restartValidationFailure(error.message));
        }
    };
};

const bulkRestartDelayedValidations = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(bulkRestartValidationsRequest());
            const response = await bulkRestartDelayedValidationsAPI();
            if(response?.status === 200){
                dispatch(bulkRestartValidationsSuccess(response?.data || null));
            } else {
                dispatch(bulkRestartValidationsFailure(response?.data?.message || 'Something went wrong'));
            }
        } catch (error: any) {
            console.log('error', error)
            //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
            dispatch(bulkRestartValidationsFailure(error.message));
        }
    };
};


const resetAll = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
    return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
        dispatch(resetValidationState())
    };
}


const actions = {
    getValidations,
    getValidation,
    getValidationLev,
    resetAll,
    getValidationHistoryIv,
    getValidationHistoryLev,
    getIvRiskSummary,
    getLevRiskSummary,
    getAPIValidations,
    getAPIValidation,
    restartValidation,
    bulkRestartDelayedValidations
}

export default actions
